<h2 mat-dialog-title>Remove : {{title}}</h2>

<mat-dialog-content>

  <ng-container *ngIf="!progressing && !done">
    <p>This action will remove package, composition, importers, screen, content and more</p>
    <mat-hint *ngIf="isLive" class="error"><b>!!! THIS CAN NOT BE UNDONE !!!</b></mat-hint>
    <mat-hint *ngIf="!isLive" class="info">You are in local environment</mat-hint>
  </ng-container>

  <ng-container *ngIf="progressing || done">
    <mat-hint *ngIf="isTest" class="info">Test Result</mat-hint>
    <ul>
      <li *ngFor="let log of protocol.log">{{log}}</li>
    </ul>
    <mat-hint class="info">{{statusInfo}}</mat-hint>
    <mat-hint class="error">{{error}}</mat-hint>
  </ng-container>

</mat-dialog-content>

<mat-dialog-actions>
  <div class="buttons">
    <button (click)="onRemove(true)" *ngIf="!done || isTest" class="ibexfusion-raised-button"
            mat-button>test
    </button>
    <button (click)="onRemove()" *ngIf="!done || isTest" class="ibexfusion-raised-button"
            mat-button>remove
    </button>
    <button (click)="onClose()" *ngIf="isTest || !progressing" class="ibexfusion-raised-button"
            mat-button>close
    </button>
  </div>
</mat-dialog-actions>
